import { IHistoryTelemetry } from '@store/Map.store';
import { LatLngExpression } from 'leaflet';

export const getTrack = (
    telemetry: IHistoryTelemetry[],
): LatLngExpression[] => {
    const result: LatLngExpression[] = [];
    telemetry.forEach(({ gpsCoord, lbsCoord }) => {
        if (gpsCoord?.lat && gpsCoord?.lon) {
            result.push({ lat: gpsCoord?.lat, lng: gpsCoord?.lon });
        } else if (lbsCoord?.lat && lbsCoord?.lon) {
            result.push({ lat: lbsCoord?.lat, lng: lbsCoord?.lon });
        }
    });
    return result;
};

export const sortTrack = (a: IHistoryTelemetry, b: IHistoryTelemetry) => {
    const dateA = a.gpsDate
        ? a.gpsDate.getTime()
        : a.lbsDate
        ? a.lbsDate.getDate()
        : 0;
    const dateB = b.gpsDate
        ? b.gpsDate.getTime()
        : b.lbsDate
        ? b.lbsDate.getDate()
        : 0;
    return dateA - dateB;
};
